'use client'

import { useTranslation } from 'react-i18next'
import { FaArrowUp, FaLeaf } from 'react-icons/fa'

import FilterDropdown from './FilterDropdown'

// Discover's filter bar under the `character_feed_filters` flag (2026-10-12): the house account now makes a minority
// of gay, lesbian and anime characters, so the grid opens on straight characters in every style, and can be sorted by
// saves. The values are what /api/get_chat_feed reads: `style` anime | realistic (anything else: every style; a
// character's style is its picture's model), `sexuality` straight (neither gay nor lesbian) | gay | lesbian, `sort`
// popular | newest (src/lib/character-feed.ts). Without the flag Discover keeps its old style and gender
// selects.
type Props = {
  style: string
  sexuality: string
  gender: string
  sort: string
  // Called with the filter's name and its new value; the parent owns sign-in and fetching guards.
  onChange: (
    filter: 'style' | 'sexuality' | 'gender' | 'sort',
    value: string,
  ) => void
}

const PILL = 'shrink-0 basis-[calc(50%-0.25rem)] md:basis-auto md:w-40'

export default function DiscoverFilters({
  style,
  sexuality,
  gender,
  sort,
  onChange,
}: Props) {
  const { t } = useTranslation()

  return (
    <div className="flex flex-wrap items-center gap-2 md:justify-end">
      <FilterDropdown
        className={PILL}
        ariaLabel="Sort"
        active
        value={sort}
        options={[
          { value: 'newest', label: t('newest'), Icon: FaLeaf },
          { value: 'popular', label: t('popular'), Icon: FaArrowUp },
        ]}
        onSelect={(value: string) => onChange('sort', value)}
      />
      <FilterDropdown
        className={PILL}
        ariaLabel="Style"
        active={style !== 'all'}
        value={style}
        options={[
          { value: 'all', label: t('allStyles') },
          { value: 'realistic', label: t('realistic') },
          { value: 'anime', label: t('anime') },
        ]}
        onSelect={(value: string) => onChange('style', value)}
      />
      <FilterDropdown
        className={PILL}
        ariaLabel="Orientation"
        active={sexuality !== 'straight'}
        value={sexuality}
        options={[
          { value: 'straight', label: t('straight') },
          { value: 'gay', label: t('gay') },
          { value: 'lesbian', label: t('lesbian') },
        ]}
        onSelect={(value: string) => onChange('sexuality', value)}
      />
      <FilterDropdown
        className={PILL}
        ariaLabel="Gender"
        active={gender !== 'all'}
        value={gender}
        options={[
          { value: 'all', label: t('allGenders') },
          { value: 'woman', label: t('women') },
          { value: 'man', label: t('men') },
        ]}
        onSelect={(value: string) => onChange('gender', value)}
      />
    </div>
  )
}
